import type { Result } from '../types';

class SavedResults {
  value = $state<Array<Result>>([]);
}

export const savedResults = new SavedResults();
